// extracted by mini-css-extract-plugin
export default {"texto":"CategoriaDoc_texto__OKr+0"};